import { render, staticRenderFns } from "./AscDescriptionsItem.vue?vue&type=template&id=13769238&scoped=true&"
import script from "./AscDescriptionsItem.vue?vue&type=script&lang=js&"
export * from "./AscDescriptionsItem.vue?vue&type=script&lang=js&"
import style0 from "./AscDescriptionsItem.vue?vue&type=style&index=0&id=13769238&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13769238",
  null
  
)

export default component.exports